module.exports = __webpack_public_path__ + "img/get-btn.4aa77f73.png";